// Components
import * as React from 'react'
import { Toolbar, ToolbarGroup, ToolbarButton } from "../components/Toolbar.js";
import { Inspector } from "../components/Inspector.js";
import { ContentBuilderStateProvider, useAppState } from './ContentBuilderStateProvider.js';
import { ContentBuilderModals } from "./ContentBuilderModals.js";
import { ContentBuilderCanvas, ContentBuilderCanvasContent } from "./ContentBuilderCanvas.js";
import { ContentBuilderValidationToolbar, ContentBuilderValidationStateProvider, checkValidationIssues } from "./ContentBuilderValidation.js"
import { ComponentSidebar } from "../components/ComponentSidebar.js";
import { PagesSidebar } from '../components/PagesSidebar.js';
import { useYapPageState } from "../uikit-components/Page.js"
import HeaderButton from "../uikit-components/HeaderButton.js"
import Modal from 'react-modal';
import { ViewStateProvider } from "../page-components/ui/View.js"
import { DebugInspector } from "../components/DebugInspector.js"

// CSS
import './YapContentBuilder.css';

// Drag drop support
import { HTML5Backend } from 'react-dnd-html5-backend'
import { DndProvider } from 'react-dnd'

function ContentBuilder(props) {
    React.useLayoutEffect(() => {
        Modal.setAppElement('#yap-content-builder')
    }, [])

    return <div id='yap-content-builder' className="polymer polymer-full-bleed ">
        <ContentBuilderStateProvider components={props.components}
                                     componentTemplates={props.componentTemplates}
                                     pages={props.pages}
                                     yapuiJSON={props.yapuiJSON}
                                     onYapUIJSONUpdated={props.onYapUIJSONUpdated}
                                     canCrop={props.canCrop}
                                     canMultiUpload={props.canMultiUpload}
                                     showDebug={props.showDebug}
                                     showSidebar={props.showSidebar}
                                     onPagesUpdated={props.onPagesUpdated}
                                     onAssetImport={props.onAssetImport}
                                     onAssetDelete={props.onAssetDelete}
                                     onAssetChange={props.onAssetChange}
                                     onDone={props.onDone}
                                     onSelectedPageId={props.onSelectedPageId}
                                     canAddAssetType={props.canAddAssetType}
                                     canInsertComponent={props.canInsertComponent}
                                     assets={props.assets ?? []}
                                     fonts={props.fonts}
                                     styles={props.styles}
                                     validations={props.validations}
                                     validationMessages={props.validationMessages}
                                     defaultTemplate={props.defaultTemplate}
                                     pageRenderer={props.pageRenderer}
                                     multiplePages={props.multiplePages}
                                     templates={props.templates ?? []}>
            <ContentBuilderContent />
        </ContentBuilderStateProvider>
    </div>
}

const addIcon = (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path className="tint-color" d="M0.241211 7.6543C0.241211 7.28516 0.370117 6.97168 0.62793 6.71387C0.891602 6.4502 1.20801 6.31836 1.57715 6.31836H6.45508V1.44922C6.45508 1.08008 6.58398 0.766602 6.8418 0.508789C7.09961 0.245117 7.41309 0.113281 7.78223 0.113281C8.15137 0.113281 8.46484 0.245117 8.72266 0.508789C8.98633 0.766602 9.11816 1.08008 9.11816 1.44922V6.31836H13.9961C14.3594 6.31836 14.6699 6.4502 14.9277 6.71387C15.1914 6.97168 15.3232 7.28516 15.3232 7.6543C15.3232 8.02344 15.1914 8.33984 14.9277 8.60352C14.6699 8.86133 14.3594 8.99023 13.9961 8.99023H9.11816V13.8682C9.11816 14.2314 8.98633 14.542 8.72266 14.7998C8.46484 15.0635 8.15137 15.1953 7.78223 15.1953C7.41309 15.1953 7.09961 15.0635 6.8418 14.7998C6.58398 14.542 6.45508 14.2314 6.45508 13.8682V8.99023H1.57715C1.20801 8.99023 0.891602 8.86133 0.62793 8.60352C0.370117 8.33984 0.241211 8.02344 0.241211 7.6543Z" fill="#384CC0" />
    </svg>
)

const viewOptionsIcon = (
    <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path className="tint-color" d="M3.04688 15.9507C2.10059 15.9507 1.37565 15.6989 0.87207 15.1953C0.36849 14.6973 0.116699 13.9779 0.116699 13.0371V2.99316C0.116699 2.05241 0.36849 1.33301 0.87207 0.834961C1.37565 0.33138 2.10059 0.0795898 3.04688 0.0795898H17.0005C17.9523 0.0795898 18.6772 0.33138 19.1753 0.834961C19.6789 1.33301 19.9307 2.05241 19.9307 2.99316V13.0371C19.9307 13.9779 19.6789 14.6973 19.1753 15.1953C18.6772 15.6989 17.9523 15.9507 17.0005 15.9507H3.04688ZM3.2793 13.8091H16.7681C17.1001 13.8091 17.3519 13.7261 17.5234 13.5601C17.7005 13.394 17.7891 13.134 17.7891 12.7798V3.25049C17.7891 2.89632 17.7005 2.63623 17.5234 2.47021C17.3519 2.3042 17.1001 2.22119 16.7681 2.22119H3.2793C2.94727 2.22119 2.69271 2.3042 2.51562 2.47021C2.34408 2.63623 2.2583 2.89632 2.2583 3.25049V12.7798C2.2583 13.134 2.34408 13.394 2.51562 13.5601C2.69271 13.7261 2.94727 13.8091 3.2793 13.8091ZM7.19727 14.083V1.89746H9.18115V14.083H7.19727ZM5.52881 5.19287H3.95166C3.76904 5.19287 3.61133 5.12923 3.47852 5.00195C3.35124 4.86914 3.2876 4.71973 3.2876 4.55371C3.2876 4.37663 3.35124 4.22445 3.47852 4.09717C3.61133 3.96989 3.76904 3.90625 3.95166 3.90625H5.52881C5.71143 3.90625 5.86914 3.96989 6.00195 4.09717C6.13477 4.22445 6.20117 4.37663 6.20117 4.55371C6.20117 4.71973 6.13477 4.86914 6.00195 5.00195C5.86914 5.12923 5.71143 5.19287 5.52881 5.19287ZM5.52881 7.54199H3.95166C3.76904 7.54199 3.61133 7.47835 3.47852 7.35107C3.35124 7.2238 3.2876 7.07438 3.2876 6.90283C3.2876 6.73128 3.35124 6.58187 3.47852 6.45459C3.61133 6.32731 3.76904 6.26367 3.95166 6.26367H5.52881C5.71143 6.26367 5.86914 6.32731 6.00195 6.45459C6.13477 6.58187 6.20117 6.73128 6.20117 6.90283C6.20117 7.07438 6.13477 7.2238 6.00195 7.35107C5.86914 7.47835 5.71143 7.54199 5.52881 7.54199ZM5.52881 9.89941H3.95166C3.76904 9.89941 3.61133 9.83577 3.47852 9.7085C3.35124 9.58122 3.2876 9.4318 3.2876 9.26025C3.2876 9.08317 3.35124 8.93376 3.47852 8.81201C3.61133 8.68473 3.76904 8.62109 3.95166 8.62109H5.52881C5.71143 8.62109 5.86914 8.68473 6.00195 8.81201C6.13477 8.93376 6.20117 9.08317 6.20117 9.26025C6.20117 9.4318 6.13477 9.58122 6.00195 9.7085C5.86914 9.83577 5.71143 9.89941 5.52881 9.89941Z" fill="#384CC0" />
    </svg>
)

function ContentBuilderContent() {

    let { inspectorModel,
        inspector,
        currentPage,
        validations,
        validationMessages,
        sidebarState,
        componentTemplates,
        components,
        setSidebarState,
        setShowSidebar,
        showSidebar,
        showTemplateLibrary,
        pages,
        setValidationEnabled,
        validationEnabled,
        contentChanged,
        setContentChanged,
        setSelected,
        updateModel,
        styles,
        isReadonly,
        multiplePages,
        refreshInspector,
        onDone } = useAppState()
       
    let pageState = useYapPageState()
    var containerClassName = pageState.canvasContainerClassName;
    var model = inspectorModel

    var hasStyles = Object.values(styles).filter( (style) => { return style.userSelectable != false }).length > 1
    if (!model && hasStyles) {
        model = { type: 'page', ...currentPage }
    }

    var sidebar = null
    var sidebarContent = null

    var hasMultiplePages = (pages.length >= 2)
    var hasComponents = (componentTemplates != null)

    var availableSidebars = []

    //if (multiplePages) {
        availableSidebars.push({
            title: "Pages",
            id: 'pages',
            content: <PagesSidebar />
        })
        sidebarContent =  <PagesSidebar />
    //}

    // if (componentTemplates != null) {
    //     availableSidebars.push({
    //         title: "Components",
    //         id: 'default',
    //         content: <ComponentSidebar />
    //     })
    // }

    if (availableSidebars.length > 0) {
        //sidebarContent = availableSidebars[0].content
        // var selected = availableSidebars.filter(f => {
        //     return f.id === sidebarState
        // })
        // if (selected.length > 0) {
        //     sidebarContent = selected[0].content
        // }
    }

    var toolbarItems = availableSidebars.map(item => {
        return <ToolbarButton text={item.title} selected={sidebarState === item.id} onClick={() => { setSidebarState(item.id) }} />
    })
    // if (sidebarState === 'templates') {
    //     sidebarContent = <TemplateSidebar />
    // } else if (sidebarState == 'pages') {
    //     sidebarContent = <PagesSidebar/>
    // } else if (componentTemplates != null) {
    //     sidebarContent = <ComponentSidebar />
    // }

    // sidebar = <div>{sidebarContent}</div>

    // if (availableSidebars.length == 1) {
    //     sidebar = sidebarContent
    // }

    var layoutLeft = <section className={`sidebar sidebar-left`}>
        <div className={`sidebar-content ${containerClassName}`}>
            {sidebarContent}
        </div>
    </section>

    const onDoneAction = () => {
        /**
         * Validate form on done
         */

        var validationPassed = true

        // If manual validation items have been passed and exist then enable validation
        if (validationMessages) {
            setValidationEnabled(true)
            validationPassed = false
            // 
        } else if (validations) {
            let issues = checkValidationIssues(validations, components, currentPage)
                .filter(a => {
                    return (a.type == 'requirement' && a.valid == false) || (a.type == 'error' && a.valid == false)
                })
            if (issues && issues.length) {
                setValidationEnabled(true)
                validationPassed = false
            }
        }

        // Call onDone callback if has been passed
        if (onDone) {
            onDone(validationPassed)
            setContentChanged(false)
            if (validationPassed) {
                setValidationEnabled(false)
                setSelected(null)
            }
        }
    }

    React.useEffect(() => {
        if (pageState) {
            pageState.setPrefersFullscreen(true)
            pageState.setPrefersLargeTitle(false)
            pageState.setHeaderTitle(currentPage ? currentPage.title : null)
            pageState.setDoneAction(() => {
                return onDoneAction
            })

            if (pageState.setHeaderActions) {

                const doneButton = <HeaderButton key={"done"} disabled={contentChanged == false} primary={true} onClick={onDoneAction}>Publish</HeaderButton>

                var leftActions = []

                // const viewOptionsButton = <HeaderButton key={"viewOptions"} onClick={() => { 
                //     setValidationEnabled(!validationEnabled)
                // }}>{viewOptionsIcon}</HeaderButton>
                // leftActions.push(viewOptionsButton)

                // if (hasComponents) {
                //     const addButton = <HeaderButton highlight={showSidebar} key={"add"} onClick={() => {
                //         setShowSidebar(!showSidebar)
                //     }}>{addIcon}</HeaderButton>
                //     leftActions.push(addButton)
                // }

                let actions = [doneButton]

                pageState.setHeaderActionsLeft(leftActions)
                pageState.setHeaderActions(actions)
            }
        }
    }, [validationMessages, validations, validationEnabled, showSidebar, contentChanged, currentPage, isReadonly])

    React.useEffect( () => {
        pageState.setHasUnsavedChanges(contentChanged)
    }, [ contentChanged ] )

    var hasTopToolbar = validationEnabled

    var className = showSidebar == true ? "active" : "inactive"

    const appContent = (
        <div className={`layout layout-app ${hasTopToolbar ? 'with-top-toolbar' : ''} `}>

            <DndProvider backend={HTML5Backend}>
                <section className="layout-left">
                    <div className={className}>{layoutLeft}
                    </div>
                    {/* {showSidebar && sidebarContent && layoutLeft} */}
                </section>

                <section className="layout-center">

                    <ContentBuilderCanvas>
                        <ContentBuilderCanvasContent />
                    </ContentBuilderCanvas>

                </section>

                <section className={`floating-overlay`}>
                        <div className={`floating-overlay-content ${containerClassName}`}>
                            <ViewStateProvider model={model}
                                updateModel={updateModel}
                                >
                                <div className={`floating-overlay-inner-content`}>
                                    <Inspector model={model} content={inspector} />
                                    <DebugInspector/>
                                </div>
                            </ViewStateProvider>
                        </div>
                    </section>

            </DndProvider>
        </div>
    )

    return (
        <div>

            <ContentBuilderModals />

            <ContentBuilderValidationStateProvider validationMessages={validationMessages}
                validations={validations}
                enabled={validationEnabled}
                onEnabled={setValidationEnabled}
                components={components}
                page={currentPage}>
                    
                <ContentBuilderValidationToolbar />
                {showTemplateLibrary == false && appContent}

            </ContentBuilderValidationStateProvider>
        </div>
    )
}

export default ContentBuilder;
